// import axios from "axios";
// import accessToken from "./jwt-token-access/accessToken"

//pass new generated access token here
// const token = accessToken
import Utils from "../pages/Utility";
import axios from 'axios';
// apply base url for axios
// const API_URL = "https://mehandipurbalaji.app";
const API_URL = Utils.API_URL;
// const axiosApi = axios.create({
//   baseURL: API_URL,
// })

// axiosApi.defaults.headers.common["Authorization"] = token

// axiosApi.interceptors.response.use(
//   response => response,
//   error => Promise.reject(error)
// )

export async function get(url, data) {
  // return await axiosApi.get(url, { ...config }).then(response => response.data)
  return fetch(API_URL + url, {
    method: 'GET',
    headers: {
      // mode: 'no-cors',
      Accept: 'application/json',
      'Content-Type': 'application/json',
      "Authorization": "Bareer " + data?.token
    },
    // body: JSON.stringify(data)
  }).then(res => res.json())

}

export async function download(url, data) {
  // return await axiosApi.get(url, { ...config }).then(response => response.data)
  return fetch(API_URL + url, {
    method: 'GET',
    headers: {
      // mode: 'no-cors',
      Accept: 'application/zip',
      'Content-Type': 'application/json',
      "Authorization": "Bareer " + data?.token
    },
    // body: JSON.stringify(data)
  }).then(res => res.blob())

}

export async function post(url, data) {
  console.log('post method req', url, data)
  return fetch(API_URL + url, {
    method: 'POST',
    headers: {
      // mode: 'no-cors',
      Accept: 'application/json',
      'Content-Type': 'application/json',
      "Authorization": "Bareer " + data?.token
    },
    body: JSON.stringify(data)
  }).then(res => res.json())
  // .post(API_URL+url, { ...data }, { ...config })
  // .then(response => response.data)
}

export async function put(url, data) {
  console.log('put method req', url, data)
  return fetch(API_URL + url, {
    method: 'PUT',
    headers: {
      // mode: 'no-cors',
      Accept: 'application/json',
      'Content-Type': 'application/json',
      "Authorization": "Bareer " + data?.token
    },
    body: JSON.stringify(data)
  }).then(res => res.json())
}

export async function upload(url, data) {
  console.log('upload method req', API_URL + url, data)
  return fetch(API_URL + url, {
    method: 'POST',
    body: data
  }).then(res => res.json())
  // const response = await axios.post(API_URL + url, data, {
  //   headers: {
  //     'Content-Type': 'multipart/form-data'
  //   },
  //   onUploadProgress: (progressEvent) => {
  //     console.log("uploading file", progressEvent);
  //     // Update progress state based on progressEvent.loaded and progressEvent.total
  //     const progress = (progressEvent.loaded / progressEvent.total) * 100;
  //     if (setProgress)
  //       setProgress(progress);
  //   },
  // });
  // console.log("response from upload", response);
  // return response.data;
  // return new Promise((resolve, reject) => {
  //   const xhr = new XMLHttpRequest();
  //   // xhr.config({"Content-Type":"multipart/form-data"})
  //   xhr.open('POST', API_URL + url, false);
  //   xhr.upload.addEventListener('progress', (event) => {
  //     console.log("progress", event);
  //     if (event.lengthComputable) {
  //       const progress = (event.loaded / event.total) * 100;
  //       if (setProgress)
  //         setProgress(progress);
  //     }
  //   });
  //   xhr.onreadystatechange = () => {
  //     if (xhr.readyState === XMLHttpRequest.DONE) {
  //       if (xhr.status === 200) {
  //         resolve(JSON.parse(xhr.responseText));
  //       } else {
  //         reject(xhr.statusText);
  //       }
  //     }
  //   };
  //   xhr.onerror = () => {
  //     reject(new Error('Network error occurred'));
  //   };
  //   xhr.send(data);
  // });
}

/**
 * @deprecated uploadS3 is deprecated. PDFs are now stored and served via the Admin project domain.
 */
export async function uploadS3(folder, data, type, onProgress) {
  console.warn("uploadS3 is deprecated. Please use the backend upload API instead.");
  throw new Error("uploadS3 has been disabled in favor of admin domain storage.");
}

export async function del(url, config = {}) {
  // return await axiosApi
  //   .delete(url, { ...config })
  //   .then(response => response.data)
}
